module.exports = __webpack_public_path__ + "img/d_5.1f129110.png";